var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgInnovationMission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 188,
    viewBox: "0 0 238 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.9042 166.16C58.3334 168.528 60.8395 170.816 63.4135 173.027L139.988 128.645L193.72 159.584C195.412 158.041 197.106 156.5 198.797 154.955C199.601 154.221 200.401 153.484 201.202 152.748L149.634 123.054L207.88 88.9637C206.792 88.243 205.708 87.5121 204.634 86.7709C202.772 85.4842 200.934 84.1617 199.109 82.8251L139.925 117.464L37.7801 62.72C35.2497 64.6891 32.6655 66.5918 30.0429 68.4382C29.802 68.6082 29.5573 68.773 29.3164 68.943L130.278 123.054L55.9042 166.161V166.16Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190.268 169.343C190.268 169.343 193.763 172.466 198.105 174.016C206.759 177.105 216.519 175.456 223.543 171.392C231.905 166.539 231.862 158.682 223.441 153.833C215.017 148.982 201.416 148.983 193.048 153.833C185.776 158.048 184.862 164.533 190.268 169.343ZM201.836 158.893C205.382 156.845 211.137 156.845 214.709 158.893C218.269 160.95 218.285 164.275 214.749 166.33C211.201 168.381 205.45 168.381 201.877 166.33C198.319 164.274 198.298 160.95 201.834 158.893H201.836Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M194.241 86.1371C194.241 86.1371 197.736 89.2601 202.078 90.8101C210.733 93.8998 220.492 92.2501 227.517 88.1867C235.878 83.3336 235.835 75.4763 227.414 70.6271C218.99 65.7765 205.389 65.7778 197.021 70.6271C189.747 74.8426 188.835 81.3274 194.241 86.1371ZM205.809 75.6872C209.355 73.6389 215.11 73.6389 218.683 75.6872C222.242 77.7445 222.258 81.0693 218.722 83.124C215.175 85.1749 209.423 85.1749 205.85 83.124C202.292 81.068 202.271 77.7445 205.808 75.6872H205.809Z",
    fill: "#E6E6E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8481 181.725C32.8481 181.725 36.3433 184.848 40.6853 186.398C49.34 189.486 59.1003 187.838 66.1239 183.774C74.4852 178.921 74.4429 171.064 66.0214 166.215C57.5974 161.364 43.996 161.366 35.6284 166.215C28.3549 170.43 27.4427 176.915 32.8481 181.725ZM44.4162 171.275C47.9627 169.227 53.7179 169.227 57.2899 171.275C60.8491 173.332 60.8658 176.657 57.3296 178.712C53.7819 180.763 48.0306 180.763 44.4572 178.712C40.8993 176.656 40.8788 173.332 44.415 171.275H44.4162Z",
    fill: "#E6E6E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46531 65.7472C3.46531 65.7472 6.96047 68.8701 11.3025 70.4201C19.9572 73.5098 29.7175 71.8602 36.7411 67.7968C45.1023 62.9436 45.0601 55.0864 36.6386 50.2371C28.2146 45.3866 14.6132 45.3878 6.24555 50.2371C-1.02792 54.4526 -1.94015 60.9375 3.46531 65.7472ZM15.0334 55.2972C18.5798 53.2489 24.3351 53.2489 27.9071 55.2972C31.4663 57.3545 31.483 60.6794 27.9468 62.7341C24.3991 64.785 18.6477 64.785 15.0744 62.7341C11.5165 60.6781 11.496 57.3545 15.0322 55.2972H15.0334Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 127.34L186.242 141.588L202.357 142.361L238.001 121.707L204.594 103.637L190.01 127.34Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.709 123.848L98.8398 138.689L115.356 139.486L151.898 117.954L117.671 99.1516L102.709 123.848Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.699 95.5699L143.203 112.244L162.489 113.161L205.126 89.0185L165.134 67.8376L147.699 95.5699Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.716 79.4734L104.221 96.1475L123.507 97.0662L166.143 72.922L126.15 51.7411L108.716 79.4734Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2099 67.6127L64.3496 73.9775L72.4149 74.3519L90.2136 65.1785L73.4655 57.0389L66.2099 67.6127Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2694 150.333L60.7852 159.545L71.4398 160.052L94.9911 146.714L72.9004 135.015L63.2694 150.333Z",
    fill: "#999999"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129.877 21.8378L129.708 81.169L103.986 96.0759L104.157 36.746L129.877 21.8378Z",
    fill: "#DBDBDB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.157 36.746L103.986 96.0759L83.9238 84.5219L84.0917 25.192L104.157 36.746Z",
    fill: "#F0F0F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M129.877 21.8378L104.157 36.746L84.0918 25.192L109.814 10.2838L129.877 21.8378Z",
    fill: "#F8F8F8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6901 45.7136L74.6261 67.9628L64.3379 73.9264L64.402 51.6772L74.6901 45.7136Z",
    fill: "#DBDBDB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4021 51.6772L64.3381 73.9264L44.9199 62.7443L44.9827 40.4951L64.4021 51.6772Z",
    fill: "#F0F0F0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.69 45.7136L64.4018 51.6771L44.9824 40.495L55.2706 34.5328L74.69 45.7136Z",
    fill: "#F8F8F8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M171.762 11.9258L171.447 95.8766L143.156 112.273L143.473 28.3227L171.762 11.9258Z",
    fill: "#31C1BB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M143.473 28.3226L143.156 112.273L122.445 100.348L122.762 16.3969L143.473 28.3226Z",
    fill: "#00B3AC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M171.762 11.9258L143.473 28.3226L122.762 16.3968L151.051 0L171.762 11.9258Z",
    fill: "#78D3D0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M121.518 66.2697L121.349 125.6L98.8457 138.643L99.0135 79.3122L121.518 66.2697Z",
    fill: "#DBDBDB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0128 79.3123L98.845 138.644L63.8984 118.521L64.0676 59.1907L99.0128 79.3123Z",
    fill: "#F0F0F0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M121.518 66.2698L99.0136 79.3124L64.0684 59.1907L86.5717 46.1469L121.518 66.2698Z",
    fill: "#F8F8F8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M119.807 177.226C120.818 177.477 129.221 173.618 129.221 173.618C129.221 173.618 151.627 151.974 154.356 133.149C157.081 114.323 137.501 92.7814 120.743 96.4017C112.389 99.4 110.016 100.466 110.016 100.466C110.016 100.466 128.235 94.5016 141.555 119.191C156.243 147.856 123.542 162.173 119.806 177.226H119.807Z",
    fill: "#E6492F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M117.383 104.391C101.385 123.265 120.764 148.382 136.814 146.573C138.731 148.028 113.346 158.099 107.391 151.609C101.435 145.112 98.1035 131.119 98.1035 119.994C98.1035 108.869 116.222 102.933 117.381 104.391H117.383Z",
    fill: "#BF3722"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M145.751 134.663C145.743 151.078 121.235 177.562 119.862 177.306C118.485 177.049 93.997 141.427 94 125.013C94.0074 108.598 105.596 97.4541 119.884 100.116C134.175 102.781 145.755 118.246 145.749 134.663H145.751ZM119.868 150.675C130.725 152.701 139.531 144.231 139.536 131.75C139.542 119.282 130.742 107.526 119.884 105.503C109.018 103.476 100.209 111.944 100.206 124.418C100.202 136.893 109.005 148.65 119.868 150.675Z",
    fill: "#FF7053"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M212.147 67.1552L211.978 126.486L186.256 141.393L186.426 82.0634L212.147 67.1552Z",
    fill: "#007BD5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M186.426 82.0635L186.256 141.393L166.193 129.839L166.361 70.5095L186.426 82.0635Z",
    fill: "#4C85DC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M212.147 67.1553L186.426 82.0635L166.361 70.5095L192.083 55.6013L212.147 67.1553Z",
    fill: "#77B3F1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3547 125.382L81.2907 147.632L60.7207 159.554L60.7835 137.304L81.3547 125.382Z",
    fill: "#DBDBDB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7841 137.304L60.7213 159.554L43.248 149.492L43.3121 127.243L60.7841 137.304Z",
    fill: "#F0F0F0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3557 125.382L60.7845 137.304L43.3125 127.243L63.8825 115.321L81.3557 125.382Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgInnovationMission);
export default __webpack_public_path__ + "static/media/img-innovation-mission.1e8c7b41a8d21ea2aef8858a47dffe7a.svg";
export { ForwardRef as ReactComponent };